var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_73)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40L40 40L40 0L0 0L0 40Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8128 28.7036C36.9709 33.0204 32.3199 37.5784 28.0521 35.3237V35.3228L25.4857 33.9565L25.4769 33.9517L25.4691 33.9478C25.2573 33.8419 25.1057 33.6748 25.0276 33.4839L25.0228 33.4722L25.0169 33.4604L15.5355 12.3823V12.3813C15.3095 11.8703 15.5199 11.2812 15.9954 11.0337L15.9993 11.0317L28.0657 4.68213L28.0677 4.68115C32.3156 2.42716 36.973 6.97839 34.8128 11.2993L31.9124 17.0991L31.9114 17.1021C31.0077 18.9283 31.0077 21.058 31.9114 22.8843L31.9124 22.8862L34.8118 28.7026L34.8128 28.7036Z",
    stroke: "#265185",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4108 28.2764C18.6368 29.1178 17.7295 29.886 16.9196 29.4541L16.9167 29.4521L7.2995 24.3857C3.75033 22.5171 3.75035 17.4489 7.2995 15.5801L10.6901 13.8008C11.2258 13.5281 11.8755 13.7487 12.1325 14.3076L18.3493 28.1074V28.1084L18.4108 28.2764Z",
    stroke: "#187550",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 40 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.162e2051cdaafd9f917ed92a8e748bb9.svg";
export { ForwardRef as ReactComponent };